module.exports = __webpack_public_path__ + "static/media/12B.a273f97a.png";